<template>
  <div>
    <el-form
      ref="formRef"
      :model="formData"
      label-width="135px"
      :rules="type == 'look' ? {} : createFormRules"
    >
      <el-row v-if="type == 'look'">
        <el-col :span="12">
          <el-form-item label="活动编号">
            <el-input disabled v-model="formData.campaignNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="活动名称" prop="campaignName">
            <el-input
              :disabled="type == 'look'"
              v-model="formData.campaignName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="活动时间 从" prop="startDate">
            <el-date-picker
              :disabled="type == 'look'"
              style="width: 50%"
              v-model="formData.startDate"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
            <span>(含)</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="至" prop="endDate">
            <el-date-picker
              :disabled="type == 'look'"
              style="width: 50%"
              v-model="formData.endDate"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
            <span>(含)</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="销售门店">
            <el-radio-group
              :disabled="type == 'look'"
              v-model="formData.isAllShop"
            >
              <el-radio :label="1">所有门店</el-radio>
              <el-radio :label="0">部分门店</el-radio>
            </el-radio-group>
            <el-button
              style="margin-left: 10px"
              :disabled="formData.isAllShop == 1 || type == 'look'"
              @click="outletVisible = true"
              >选择门店</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            prop="listOfSomeStoreslStr"
            :rules="
              formData.isAllShop == 0 && type != 'look'
                ? [
                    {
                      required: true,
                      message: '请选择部分门店',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <textarea
              style="width: 50%"
              rows="8"
              readonly
              v-model="formData.listOfSomeStoreslStr"
            ></textarea>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="用户类型" prop="joinCustomerFlag">
            <el-select
              :disabled="type == 'look'"
              v-model="formData.joinCustomerFlag"
            >
              <el-option
                v-for="item in customerType"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.joinCustomerFlag == 14">
        <el-col :span="24">
          <el-form-item
            label="用户分组"
            prop="custGrpName"
            :disabled="type == 'look'"
            :rules="
              formData.joinCustomerFlag == 14 && type != 'look'
                ? [
                    {
                      required: true,
                      message: '请选择用户分组',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <div>
              <el-input
                style="width: 80%"
                readonly
                v-model="formData.custGrpName"
              ></el-input>
              <el-button
                @click="userGroupingShow = true"
                style="margin-left: 15px"
                :disabled="type == 'look'"
                >选择分组</el-button
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.joinCustomerFlag == 3">
        <el-col :span="24">
          <el-form-item
            label="会员等级"
            prop="custLvl"
            :rules="
              formData.joinCustomerFlag == 3 && type != 'look'
                ? [
                    {
                      type: 'array',
                      required: true,
                      message: '请至少选择一个会员等级',
                      trigger: 'change',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-checkbox
              :disabled="type == 'look'"
              v-model="formData.custLvl"
              v-for="item in checkbooksData"
              :key="item.levelID"
              :value="item.levelID"
              :label="item.levelID"
            >
              {{ item.levelName_cn }}
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="活动限制">
          <el-col :span="10">
            <el-radio-group
              :disabled="type == 'look'"
              v-model="formData.actLimit"
            >
              <el-radio :label="0">无限制</el-radio>
              <el-radio :label="3">有限制 每个会员</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="10">
            <el-select
              v-model="formData.wholeOrDay"
              :disabled="type == 'look' ? true : formData.actLimit == 0"
            >
              <el-option :value="2" label="总共"></el-option>
              <el-option :value="1" label="每天"></el-option>
            </el-select>
          </el-col>
          <el-col :span="3" style="display: flex">
            <el-input
              v-model="formData.limitNum"
              :disabled="type == 'look' ? true : formData.actLimit == 0"
            ></el-input
            >次
          </el-col>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="满赠规则">
          <el-form-item
            label-width="110px"
            label="满赠起始金额"
            prop="lvlStartAmount"
          >
            <el-input
              oninput="value=value.replace(/[^0-9]/g,'')"
              :disabled="type == 'look'"
              v-model="formData.lvlStartAmount"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label-width="110px"
            label="满赠区间金额"
            prop="lvlAmount"
            style="margin-top: 20px"
          >
            <el-input
              oninput="value=value.replace(/[^0-9]/g,'')"
              :disabled="type == 'look'"
              v-model="formData.lvlAmount"
              style="width: 150px"
            ></el-input>
          </el-form-item>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="赠券形式">
            <el-radio-group
              :disabled="type == 'look'"
              v-model="formData.coupGrpCreateFlag"
            >
              <el-radio :label="1">券面额累加</el-radio>
              <el-radio :label="0">券数量累加</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.coupGrpCreateFlag == 1">
        <el-col :span="24">
          <el-form-item label="劵递增金额" prop="coupLvlAmt">
            <el-input
              oninput="value=value.replace(/[^0-9]/g,'')"
              :disabled="type == 'look'"
              style="width: 200px"
              v-model="formData.coupLvlAmt"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.presentedKind == 0">
        <el-col :span="24">
          <el-form-item
            label="券库"
            prop="presentedqk"
            :rules="
              formData.presentedKind == 0 && type != 'look'
                ? [
                    {
                      required: true,
                      message: '请选择券库',
                      trigger: 'change',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <div class="xiaoguo">
              <el-input
                readonly
                style="width: 80%"
                v-model="formData.presentedqk"
                @click.native="Juankubtn"
              ></el-input>
              <el-button
                :disabled="type == 'look'"
                @click="weachTher"
                style="margin-left: 15px"
                >选择</el-button
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="抄送人员">
            <el-input
              readonly
              style="width: 80%"
              v-model="formData.chaosong"
            ></el-input>
            <el-button
              style="margin-left: 15px"
              :disabled="type == 'look'"
              @click="sysempselectEmpList(), (innerVisiblery = true)"
              >选择</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="发放方式">
            <el-radio-group
                v-model="formData.sendMode"
                @change="sendModeRadioChange"
                :disabled="type == 'look'"
            >
              <el-radio :label="0">立即发送</el-radio>
              <el-radio :label="1">定时发送</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="发放取消规则"
                        prop="saleLimieFlag"
                        :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择发放取消规则',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-select
                :disabled=" type === 'look' ? true : formData.sendMode == 1 ? false : true
              "
                v-model="formData.saleLimieFlag"
            >
              <el-option
                  v-for="item in saleLimieFlagType"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item style="width: 57%" label="发放间隔天数"
                        :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                       message: '请输入发放间隔天数',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-input
                oninput="value=value.replace(/[^0-9]/g,'')"
                :disabled="type == 'look' ? true : formData.sendMode == 1 ? false : true
              "
                v-model="formData.disIntervalDay"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
              label="定时发送时间点"
              prop="issueTime"
              :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择定时发送时间',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
          >
            <el-time-picker
                value-format="HH:mm:ss"
                style="width: 36%; margin-left: 10px"
                v-model="formData.issueTime"
                placeholder="任意时间点"
                :disabled="type == 'look' ? true : formData.sendMode == 1 ? false : true
              "
            >
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="type != 'look'" @click="formRules">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>

    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog
        append-to-body
        width="30%"
        :visible.sync="outletVisible"
        title="选择门店"
      >
        <el-form size="mini" label-width="90px">
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="ShopID"
                highlight-current
                default-expand-all
                :default-checked-keys="shopId"
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择员工 -->
    <div class="choice">
      <div class="alteration">
        <el-dialog
          append-to-body
          width="50%"
          title="选择分组"
          :visible.sync="userGroupingShow"
          :close-on-click-modal="false"
        >
          <userGrouping
            @submit="getChangeProductInfo"
            @close="userGroupingShow = false"
          ></userGrouping>
        </el-dialog>
        <el-dialog
          append-to-body
          width="80%"
          title="券库详情"
          :visible.sync="quankuShow"
          :close-on-click-modal="false"
        >
          <quanku ref="quanku"></quanku>
        </el-dialog>
      </div>
    </div>
    <!-- 选择劵库弹窗 -->
    <div>
      <el-dialog
        width="40%"
        title="选择券库"
        append-to-body
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
      >
        <el-form size="mini" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="券名称">
                <el-input v-model="queryArr.couponsName"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="券类型">
                <div class="flex-between">
                  <el-select style="width: 100%" v-model="queryArr.couponsKind">
                    <el-option label="现金券" value="0"> </el-option>
                  </el-select>
                  <el-button
                    icon="el-icon-search"
                    style="margin-left: 3%"
                    @click="Securitieslibrary()"
                    >查询</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryArr.createTime"
                  type="date"
                  placeholder="选择时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="至">
                <el-date-picker
                  v-model="queryArr.updateTime"
                  type="date"
                  placeholder="选择时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width: 100%; margin-top: 10px">
          <el-table
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable"
            :data="queryList"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="load"
            v-loading="loading"
            infinite-scroll-disabled="onLoading"
          >
            <el-table-column width="40">
              <template slot-scope="scope">
                <el-radio
                  v-model="radioId"
                  :label="scope.$index"
                  @change.native="handleRadioChange(scope.row)"
                  >&nbsp;
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="couponsName" label="券名称">
            </el-table-column>
            <el-table-column prop="innerCoupName" label="券后台名称">
            </el-table-column>
            <el-table-column prop="couponsKind" label="券类型">
              <template scope="scope">
                {{
                  scope.row.couponsKind === 0
                    ? " 现金券"
                    : "" || scope.row.couponsKind === 1
                    ? "折扣券"
                    : "" || scope.row.couponsKind === 2
                    ? "礼品券"
                    : "" || scope.row.couponsKind === 3
                    ? "异业券"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="coupValue" label="券值"></el-table-column>
            <el-table-column prop="giftNo" label="礼品编号"></el-table-column>
            <el-table-column prop="giftName" label="礼品名称"></el-table-column>
            <el-table-column prop="createUserName" label="创建人">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间">
              <template scope="scope">
                {{ scope.row.createTime | dateFormats }}
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMore"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="determine">确 定</el-button>
          <el-button @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择员工 -->
    <div class="choice">
      <el-dialog
        append-to-body
        width="45%"
        title="选择员工"
        :visible.sync="innerVisiblery"
      >
        <el-form size="mini" label-width="200px">
          <el-form-item label="会员姓名\会员卡号\手机号">
            <div class="flex-between">
              <el-input style="width: 300px" v-model="queryArrry.search">
              </el-input>
              <el-button
                style="
                  width: 80px;
                  margin-left: 10px;
                  background-color: #f1f1f1;
                  color: #b6b388;
                "
                size="mini"
                icon="el-icon-search"
                @click="sysempselectEmpList()"
                >查询</el-button
              >
            </div>
          </el-form-item>
        </el-form>
        <div style="width: 100%">
          <el-table
            size="mini"
            height="300"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTableUser"
            :data="queryListry"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="loadry"
            v-loading="loadingry"
            infinite-scroll-disabled="onLoadingry"
            @select="handleSelectionChange"
          >
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" label="选择" width="50">
            </el-table-column>
            <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
            <el-table-column prop="custName" label="会员姓名">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号"> </el-table-column>
            <el-table-column prop="levelName" label="消费等级">
            </el-table-column>
            <el-table-column prop="regionName" label="所属区域">
            </el-table-column>
            <el-table-column prop="shopName" label="所属门店">
            </el-table-column>
            <el-table-column prop="serviceEmpName" label="维护品牌顾问">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="isMorery"
            title="没有更多啦!"
            type="warning"
            center
            show-icon
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectemployees">确 定</el-button>
          <el-button @click="innerVisiblery = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  shopQueryRegionApi,
  couponsGroupApi,
  custselectCustList,
  marketingInsertApi,
  marketingEitApi,
} from "@/api/marketing";
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import { getcpyNo } from "@/utils/auth";
import { dateTimes } from "@/utils/auth";
import userGrouping from "/src/components/userGrouping/index.vue";
import quanku from "/src/components/quanku.vue";

const customerType = [
  {
    value: 1,
    label: "所有会员",
  },
  {
    value: 2,
    label: "VIC会员",
  },
  {
    value: 3,
    label: "会员等级",
  },
  {
    value: 10,
    label: "本月生日会员",
  },
  {
    value: 11,
    label: "生日当天会员",
  },
  {
    value: 12,
    label: "本月注册会员",
  },
  {
    value: 13,
    label: "今年注册会员",
  },
  {
    value: 14,
    label: "会员分组",
  },
];
export default {
  components: {
    userGrouping,
    quanku,
  },
  data() {
    return {
      type: "add",
      formData: {
        custLvl: [],
        wholeOrDay: "",
        startDate: "",
        endDate: "",
        couponsKind: "",
        campaignName: "",
        isAllShop: 1,
        joinCustomerFlag: "",
        CCID: [],
        runTimeFlag: 0,
        sendMode: 0,
        saleLimieFlag: "",
        issueTime: "",
        disIntervalDay: "",
        presentedKind: 0,
        chaosong: "",
        listOfSomeStoresl: [],
        ccMap: [],
        actLimit: 0,
        saleLimit: 0,
        saleScope: 0,
        custGrpName: "",
        customerGrpID: "",
        lvlStartAmount: "",
        lvlAmount: "",
        coupGrpCreateFlag: 1,
        presentedqk: "",
        coupLvlAmt: "",
      },
      createFormRules: {
        lvlStartAmount: [
          { required: true, message: "请输入满赠起始金额", trigger: "blur" },
        ],
        lvlAmount: [
          { required: true, message: "请输入满赠区间金额", trigger: "blur" },
        ],
        campaignName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        coupLvlAmt: [
          { required: true, message: "请输入劵递增金额", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        joinCustomerFlag: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        runMonth: [
          { required: true, message: "请选择执行月", trigger: "blur" },
        ],
        runDay: [{ required: true, message: "请选择执行日", trigger: "blur" }],
        timeRange: [
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ],
        listOfSomeStoreslStr: [
          { required: true, message: "请选择门店", trigger: "blur" },
        ],
        custLvl: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个会员等级",
            trigger: "change",
          },
        ],
      },
      outletVisible: false, //选择部分门店，选择门店弹框
      shopId: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      checkbooksData: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      customerType,
      userGroupingShow: false,
      innerVisible: false,
      queryList: [],
      queryArr: {
        state: 0,
        couponsName: "", //卷名称
        couponsKind: "0", //卷类型
        createTime: "",
        updateTime: "",
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      }, // 内层弹窗请求数据
      loading: false,
      // 选择券库radio数据
      radioId: "",
      templatei: {},
      quankuShow: false,
      innerVisiblery: false,
      // 选择人员参数
      queryListry: [],
      queryArrry: {
        empCode: "", //员工编号
        empName: "", //员工姓名
        empKind: "", //员工类型
        shopNameOrCode: "", // 门店编号\名称
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      },
      loadingry: false,
      arrry: [],
      saleLimieFlagType: [
        {
          value: 0,
          label: "不取消",
        },
        {
          value: 1,
          label: "原销售单仅全部退货时取消",
        },
        {
          value: 2,
          label: "原销售单退货时取消",
        },
      ],
    };
  },
  created() {
    this.ShopqueryRegionList();
  },
  computed: {
    // 选择券库弹窗
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryArr.pageNo >= this.queryArr.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 选择人员弹窗
    isMorery() {
      //当起始页数等于总页数时停止加载
      return this.queryArrry.pageNo >= this.queryArrry.pages;
    },
    onLoadingry() {
      return this.loadingry || this.isMorery;
    },
  },
  methods: {
    getDetails(res, type) {
      if (type) this.type = type || "add"; //操作类型
      if (res && res.success) {
        let formData = res.data;
        formData.isAllShop = res.data.isAllShop ? 1 : 0;
        if (res.data.actLimit != 0) {
          formData.wholeOrDay = res.data.actLimit;
          formData.actLimit = 3;
        }
        formData.listOfSomeStoreslStr = "";
        this.shopId = [];
        formData.listOfSomeStoresl = [];
        for (let i = 0; i < res.shopList.length; i++) {
          this.shopId.push(res.shopList[i].ShopID);
          formData.listOfSomeStoreslStr += `${res.shopList[i].ShopName}\n`;
          let str = {
            shopID: res.shopList[i].ShopID,
            id: res.shopList[i].ShopID,
          };
          formData.listOfSomeStoresl.push(str);
        }
        if (res.data.presentedKind == 0) {
          formData.presentedqk = res.data.couponsName;
          formData.presentedObjIDqk = res.data.presentedObjID;
        }
        formData.ccMap = [];
        if (res.data.cc1) formData.ccMap.push(res.data.cc1);
        if (res.data.cc2) formData.ccMap.push(res.data.cc2);
        if (res.data.cc3) formData.ccMap.push(res.data.cc3);
        formData.chaosong =
          res.data.cc1Name + "," + res.data.cc2Name + "," + res.data.cc3Name;
        let custLvl = [];
        for (let i = 0; i < res.custLvl.length; i++) {
          custLvl.push(res.custLvl[i].LevelID);
        }
        formData.custLvl = custLvl;
        this.formData = JSON.parse(JSON.stringify(formData));
      } else {
        this.formData = {
          custLvl: [],
          wholeOrDay: "",
          startDate: "",
          endDate: "",
          couponsKind: "",
          campaignName: "",
          isAllShop: 1,
          joinCustomerFlag: "",
          CCID: [],
          runTimeFlag: 0,
          sendMode: 0,
          saleLimieFlag: '',
          disIntervalDay: '',
          issueTime: '',
          presentedKind: 0,
          chaosong: "",
          listOfSomeStoresl: [],
          ccMap: [],
          actLimit: 0,
          saleLimit: 0,
          saleScope: 0,
          custGrpName: "",
          customerGrpID: "",
          lvlStartAmount: "",
          lvlAmount: "",
          coupGrpCreateFlag: 1,
          presentedqk: "",
          listOfSomeStoreslStr: "",
          coupLvlAmt: "",
        };
        this.$nextTick(() => {
          this.$refs["formRef"].resetFields();
        });
      }
    },
    //接口调用成功返回
    success() {
      this.shopId = [];
      this.$emit("success");
    },
    //取消
    cancel() {
      this.shopId = [];
      this.$emit("close");
    },
    formRules() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
      return;
    },
    submit() {
      let queryData = {
        campaignName: this.formData.campaignName, //活动名称
        isAllShop: this.formData.isAllShop, //是否全部门店
        compaignKind: "2", //活动类型
        giftGiveMode: 1, //消费行为giftGiveMode=0、消费满赠giftGiveMode=1
        presentedKind: this.formData.presentedKind, //赠送内容
        startDate: dateTimes(this.formData.startDate), //开始执行日期
        endDate: dateTimes(this.formData.endDate), //结束执行日期
        shopID: this.formData.isAllShop === 0 ? this.shopId.toString() : [], //部分门店id
        custLvl: this.formData.custLvl.toString(), //会员等级
        joinCustomerFlag: this.formData.joinCustomerFlag, //用户类型
        customerGrpID: this.formData.customerGrpID, //会员分组id
        actLimit:
          this.formData.actLimit == 0
            ? 0
            : this.formData.wholeOrDay == 1
            ? "1"
            : "2", //活动限制
        limitNum: this.formData.actLimit != 0 ? this.formData.limitNum : null, //次数
        lvlStartAmount: this.formData.lvlStartAmount,
        lvlAmount: this.formData.lvlAmount,
        coupGrpCreateFlag: this.formData.coupGrpCreateFlag,
        presentedObjID: this.formData.presentedObjIDqk,
        sendMode: this.formData.sendMode,
        saleLimieFlag: this.formData.saleLimieFlag, //定时发放时销售单限制
        disIntervalDay:
            this.formData.sendMode == 1
                ? this.formData.disIntervalDay
                : null,
        issueTime:
            this.formData.sendMode == 1 ? this.formData.issueTime : null, //执行时间
        CC1: this.formData.ccMap.length > 0 ? this.formData.ccMap[0] : "",
        CC2: this.formData.ccMap.length > 1 ? this.formData.ccMap[1] : "",
        CC3: this.formData.ccMap.length > 2 ? this.formData.ccMap[2] : "",
        coupLvlAmt:
          this.formData.coupGrpCreateFlag == 1 ? this.formData.coupLvlAmt : "",
      };
      if (this.type == "add") {
        marketingInsertApi(queryData).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建活动失败!");
            return;
          } else {
            this.$message.success("创建活动成功!");
            this.success();
          }
        });
      } else if (this.type == "edit") {
        queryData.campaignID = this.formData.campaignID;
        // queryData.state = this.formData.state;
        marketingEitApi(queryData).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改活动失败!");
            return;
          } else {
            this.$message.success("修改活动成功!");
            this.success();
            // 隐藏创建弹窗
          }
        });
      }
      console.log("queryData", queryData);
    },
    //选择人员列表触底加载
    loadry() {
      this.loadingry = true;
      this.queryArrry.pageNo += 1;
      this.sysempselectEmpList();
    },
    // 选择员工确定事件
    Selectemployees() {
      this.formData.chaosong = "";
      this.formData.ccMap = [];
      this.arrry.forEach((item) => {
        this.formData.chaosong += item.custName + ",";
        this.formData.ccMap.push(item.custID);
      });
      this.formData.chaosong = this.formData.chaosong.substring(
        0,
        this.formData.chaosong.length - 1
      );
      this.innerVisiblery = false;
    },
    //控制选择人员列表最多选择三个
    handleSelectionChange(selection, index) {
      if (selection.length >= 4) {
        this.$message({
          message: "只能选中3个!",
          type: "warning",
        });
        this.$refs.multipleTableUser.toggleRowSelection(index, false);
        selection.length = 3;
      }
      this.arrry = selection;
    },
    // 选择人员数据请求
    async sysempselectEmpList() {
      await custselectCustList(this.queryArrry).then((res) => {
        if (this.queryArrry.pageNo == 1) this.queryListry = [];
        this.queryListry = this.queryListry.concat(res.data.list);
        this.queryArrry.pages = res.data.pages;
        this.loadingry = false;
      });
    },
    // 选择券库确定事件
    determine() {
      this.$set(this.formData, "presentedqk", this.templatei.couponsName);
      this.formData.presentedObjIDqk = this.templatei.couponsGrpID;
      this.radioId = "";
      this.innerVisible = false;
    },
    // 选择券库弹窗radio选中数据
    handleRadioChange(val) {
      this.templatei = val;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    load() {
      this.loading = true;
      this.queryArr.pageNo += 1;
      this.Securitieslibrary();
    },
    //选择劵库数据请求
    async Securitieslibrary() {
      await couponsGroupApi(this.queryArr).then((res) => {
        if (this.queryArr.pageNo == 1) this.queryList = [];
        this.queryList = this.queryList.concat(res.data.list);
        this.queryArr.pages = res.data.pages;
        this.loading = false;
      });
    },
    //点击选中劵库获取数据
    weachTher() {
      this.Securitieslibrary();
      this.innerVisible = true;
    },
    Juankubtn() {
      if (this.formData.presentedObjIDqk) {
        this.quankuShow = true;
        this.$nextTick(() => {
          this.$refs.quanku.RcouponsGroupDetail(this.formData.presentedObjIDqk);
        });
      }
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      this.formData.listOfSomeStoresl = [];
      this.formData.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.formData.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.formData.listOfSomeStoresl.push(...item);
        }
      }
      this.formData.listOfSomeStoresl.forEach((item) => {
        this.formData.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      this.shopId = [];
      for (let i = 0; i < this.formData.listOfSomeStoresl.length; i++) {
        this.shopId.push(this.formData.listOfSomeStoresl[i].id);
      }
      this.outletVisible = false;
    },
    // 获取区域门店 and 会员类型
    ShopqueryRegionList() {
      queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
        this.checkbooksData = res.data;
      });
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getChangeProductInfo(data) {
      console.log(data);
      this.formData.custGrpName = data.custGrpName;
      this.formData.customerGrpID = data.customerGrpID;
      this.userGroupingShow = false;
    },
    sendModeRadioChange(index) {
      if (index == 0) {
        this.formData.disIntervalDay = '';
        this.formData.issueTime = '';
        this.formData.saleLimieFlag = '';
      } else {
        this.formData.saleLimieFlag = 0;
        this.formData.disIntervalDay = 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.el-button:hover {
  background-color: #b5b386;
  color: #f2f2f2;
}
/deep/.xiaoguo .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
</style>
